export default from './FooterMobile';



// WEBPACK FOOTER //
// ./src/components/FooterMobile/index.js